import { useEffect, useState } from 'react';

function readCoarsePointer() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(pointer: coarse)').matches;
}

/**
 * 優先偵測 `(pointer: coarse)`：平板／觸控手機為 true；
 * 筆電觸控板（fine pointer）為 false，仍走延遲 Tooltip。
 */
export function useCoarsePointer() {
  const [isCoarse, setIsCoarse] = useState(readCoarsePointer);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mediaQuery = window.matchMedia('(pointer: coarse)');
    function handleChange(event) {
      setIsCoarse(event.matches);
    }
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isCoarse;
}
